const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://tnjvdswykmzvxcwfoycj.supabase.co';
const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  '';

const SESSION_KEY = 'funnel_session_id';

const getSessionId = (): string => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
};

export type FunnelStep =
  | 'page_view'
  | 'product_view'
  | 'add_to_cart'
  | 'checkout_start'
  | 'payment_info'
  | 'purchase';

const getDeviceType = (): string => {
  if (typeof navigator === 'undefined') return 'unknown';
  return /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
};

export const trackFunnelEvent = (
  step: FunnelStep,
  page: string,
  productId?: string
) => {
  try {
    const payload = {
      session_id: getSessionId(),
      step,
      page,
      product_id: productId || null,
      device_type: getDeviceType(),
    };

    const url = `${SUPABASE_URL}/functions/v1/log-funnel-event`;
    const body = JSON.stringify(payload);

    const requestInit: RequestInit = {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(SUPABASE_ANON_KEY ? { apikey: SUPABASE_ANON_KEY } : {}),
      },
      body,
    };

    fetch(url, requestInit).catch(() => {});
  } catch {
    // never throw from funnel tracker
  }
};
